import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login-form/app.logincomponent';
import { PraMainComponent } from './pra-main/pra-main.component';
import { PraNewRequestComponent } from './pra-new-request/pra-new-request.component';
import { PraConfirmRequestComponent } from './pra-confirm-request/pra-confirm-request.component';
import { PraSearchRequestsComponent } from './pra-search-requests/pra-search-requests.component';
import { PraSearchByEidComponent } from './pra-search-by-eid/pra-search-by-eid.component';
import { PraDetailsComponent } from './pra-details/pra-details.component';
import { PraAdminEditComponent } from './pra-admin-edit/pra-admin-edit.component';
import { PraNotAuthorizedComponent } from './pra-not-authorized/pra-not-authorized.component';
import { AuthGuard } from './auth-guard/auth.guard';
import { OktaCallbackComponent } from '@okta/okta-angular';

const routes: Routes = [
  {
    path: '',
    component: PraMainComponent,
    data: { depth: 2 },
    canActivate: [AuthGuard],
    children: [
      { path: 'view-adjustment-records', component: PraSearchRequestsComponent, data: { depth: 1 } },
      { path: 'view-adjustment-records/pra-details', component: PraDetailsComponent, data: { depth: 2 } },
      { path: 'view-adjustment-records/search-eid', component: PraSearchByEidComponent, data: { depth: 1 } },
      { path: 'new-request', component: PraNewRequestComponent, data: { depth: 1 } },
      { path: 'not-authorized', component: PraNotAuthorizedComponent, data: { depth: 1 } },
      { path: 'new-request/confirm', component: PraConfirmRequestComponent, data: { depth: 2 } },
      { path: 'admin-edit', component: PraAdminEditComponent, data: { depth: 1 } }
    ]
  },
  { path: 'login', component: LoginComponent, data: { depth: 1 } },
  { path: 'login/callback', component: OktaCallbackComponent, data: { depth: 1 } },
  // otherwise redirect to home
  { path: '**', redirectTo: 'new-request' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
